// extracted by mini-css-extract-plugin
export default {"App":"App_App__lBHUN","switch-wrapper":"App_switch-wrapper__FHuk6"};